import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation, Types } from '@grandvisionhq/graphql';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/loyalty-point-failure.js';
import { SET_LOYALTY_DETAILS } from '../operations/mutations/set-loyalty-details.js';

const useSetLoyaltyDetails = ({ onError , onCompleted  } = {})=>{
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React.useCallback((responseData)=>{
        let result;
        if (responseData.setLoyaltyDetails) {
            var ref;
            result = responseData.setLoyaltyDetails;
            if (result.success) {
                var ref1;
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
                (result === null || result === void 0 ? void 0 : (ref1 = result.cart) === null || ref1 === void 0 ? void 0 : ref1.loyaltyDetails.cardNumberType) == 'LUHN' && toast.success('cart.loyaltyCardUpdate.success');
            }
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                result.failures.forEach((item)=>{
                    switch(item.__typename){
                        case 'UnknownSetLoyaltyDetailsFailure':
                            console.error(`useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`);
                            toast.failed('cart.errors.loyaltyCardUpdate.failed');
                            return;
                        case 'InvalidLoyaltyCardNumber':
                            console.error(`useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`);
                            toast.failed('cart.loyalty.invalidNumber');
                            return;
                        default:
                            console.error(`useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`);
                            toast.failed('cart.errors.loyaltyCardUpdate.failed');
                    }
                });
            }
        }
    }, [
        onCompleted
    ]);
    const handleOnError = React.useCallback((e)=>{
        console.error('useSetLoyaltyDetails:', e);
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed('cart.errors.loyaltyCardUpdate.failed');
    }, [
        onError
    ]);
    const [setLoyaltyDetails, setLoyaltyDetailsMutation] = useMutation(SET_LOYALTY_DETAILS, {
        onCompleted: handleOnCompleted,
        onError: handleOnError
    });
    /**
   *  Loyalty card data update operation
   *  @param cardNumber: number
   */ const setLoyaltyCardNumber = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(cardNumber, cartId, cartHash, type) {
            if (!cartId) {
                console.error('CartId required to perform update ');
                return;
            }
            yield setLoyaltyDetails(swcHelpers.objectSpread({
                variables: {
                    input: {
                        cardNumber,
                        cartId,
                        cardNumberType: type !== null && type !== void 0 ? type : Types.LoyaltyCardNumber.LUHN
                    }
                }
            }, cartHash ? {
                context: {
                    forwardHeaders: {
                        'cart-hash': cartHash
                    }
                }
            } : {}));
        });
        return function(cardNumber, cartId, cartHash, type) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setLoyaltyDetails
    ]);
    const { loading , error  } = setLoyaltyDetailsMutation;
    return {
        setLoyaltyCardNumber,
        isUpdating: loading,
        updateError: error
    };
};

export { useSetLoyaltyDetails };
//# sourceMappingURL=use-set-loyalty-details.js.map
